import React, { useState } from 'react';

const cormorantFont = { fontFamily: "'Cormorant Garamond', serif" };

function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      {/* Header */}
      <header className="shadow-md" style={{ backgroundColor: '#343a40' }}>
        <div className="max-w-7xl mx-auto flex items-center justify-between px-4 py-2">
          <div className="flex items-center space-x-4">
            <img src={process.env.PUBLIC_URL + '/logo-2.png'} alt="Club Logo" className="h-16 sm:h-24 w-auto rounded shadow" />
            <span className="text-xl sm:text-2xl md:text-3xl font-bold text-white tracking-wide drop-shadow" style={cormorantFont}>Glenullin GAC</span>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <a href="/" className="text-white hover:text-green-200 font-medium transition">Home</a>
            <a href="/news" className="text-white hover:text-green-200 font-medium transition">News</a>
            <a href="/history" className="text-white hover:text-green-200 font-medium transition">History</a>
            <a href="/teams" className="text-white hover:text-green-200 font-medium transition">Teams</a>
            <a href="/lotto" className="text-white hover:text-green-200 font-medium transition">Lotto</a>
            <a href="/whats-on" className="text-white hover:text-green-200 font-medium transition">What's On</a>
           
            <a href="/eagle" className="text-white hover:text-green-200 font-medium transition">Eagle</a>
            <a href="/contact" className="text-white hover:text-green-200 font-medium transition">Contact</a>
           
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMobileMenu}
            className="md:hidden text-white hover:text-green-200 p-2"
            aria-label="Toggle mobile menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              {isMobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-gray-800 border-t border-gray-700">
            <nav className="flex flex-col space-y-2 px-4 py-4">
              <a 
                href="/" 
                className="text-white hover:text-green-200 font-medium transition py-2 border-b border-gray-700"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Home
              </a>
              <a 
                href="/news" 
                className="text-white hover:text-green-200 font-medium transition py-2 border-b border-gray-700"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                News
              </a>
              <a 
                href="/history" 
                className="text-white hover:text-green-200 font-medium transition py-2 border-b border-gray-700"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                History
              </a>
              <a 
                href="/teams" 
                className="text-white hover:text-green-200 font-medium transition py-2 border-b border-gray-700"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Teams
              </a>
              <a 
                href="/lotto" 
                className="text-white hover:text-green-200 font-medium transition py-2 border-b border-gray-700"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Lotto
              </a>
              <a 
                href="/whats-on" 
                className="text-white hover:text-green-200 font-medium transition py-2 border-b border-gray-700"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                What's On
              </a>
              <a 
                href="/eagle" 
                className="text-white hover:text-green-200 font-medium transition py-2 border-b border-gray-700"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Eagle
              </a>
              <a 
                href="/contact" 
                className="text-white hover:text-green-200 font-medium transition py-2"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Contact
              </a>
            </nav>
          </div>
        )}
      </header>
    </>
  );
}

export default Header; 